import { BankidIcon } from 'Atoms/Icons';

const BankIdIcon = () => {
  return <BankidIcon css={cssBankidIcon} size="m" fillColor="secondaryDark" />;
};

const cssBankidIcon = { position: 'absolute', left: '24px', top: '12px' };

export default BankIdIcon;
